<template>
    <form :action="formAction" method="post" @submit="validate">
        <slot name="csrf-token"></slot>
        <slot name="input-next"></slot>

        <div class="form-row">
            <div class="form-group col">
                <label :class="emailError ? 'error-anchor' : ''">
                    {{ emailLabel }}
                </label>
                <input 
                    name="email" 
                    v-model='email' 
                    :class="emailError ? 'is-invalid error-anchor' : ''" 
                    type="email"
                    class="form-control" 
                    :placeholder="emailLabel"
                >
                <div class="invalid-feedback" v-if="emailError">
                    {{ emailError }}
                </div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-group col">
                <turnstile 
                    v-if="showTurnstile" 
                    :class="!isRecaptchaFilled ? 'border-error error-anchor' : ''"
                    :sitekey="newCaptchaSiteKey" 
                    :language="language"
                />
                <hcaptcha 
                    v-else-if="showHcaptcha" 
                    :class="!isRecaptchaFilled ? 'border-error error-anchor' : ''"
                    :sitekey="newCaptchaSiteKey" 
                    :language="language"
                />
                <recaptcha 
                    v-else 
                    :class="!isRecaptchaFilled ? 'border-error error-anchor' : ''"
                    :sitekey="recaptchaPublicKey"
                    :language="language"
                />
            </div>
        </div>
        <ui-button 
            type="submit"
            appearance="primary"
            :disabled="!isRecaptchaFilled || !isEmailValid || submittedForm"
            :label="btnLabel"
            block
        />
    </form>
</template>

<script>
// import Translations from "./insert-me-to-translate.vue";

import Recaptcha from './recaptcha';
import Hcaptcha from './hcaptcha';
import Turnstile from './turnstile';
import { mapGetters } from "vuex";
import { isValidEmail } from "../services/email_validator";

export default {
    props: {
        initEmail: {
            type: String,
            default: '',
        }, 
        initEmailError: {
            type: String,
            default: '',
        },
        initGeneralError: {
            type: String,
            default: '',
        },
        formAction: {
            type: String,
            default: '',
        },
        showTurnstile: {
            type: Boolean,
            require: true
        },
        showHcaptcha: {
            type: Boolean,
            require: true
        },
        btnLabel: {
            type: String,
            default: '',
        },
        emailLabel: {
            type: String,
            default: '',
        },
        recaptchaPublicKey: {
            type: String,
            require: true
        },
        newCaptchaSiteKey: {
            type: String,
            require: true
        },
        language: {
            type: String,
            require: true
        },
    },
    components: {
        Recaptcha,
        Hcaptcha,
        Turnstile,
        UiButton: () => import(/* webpackChunkName: "chunk-ui-button" */ './ui/ui-button.vue'),
    },
    data() {
        return  {
            email: this.initEmail,
            emailError: this.initEmailError,
            generalError: this.initGeneralError,
            submittedForm: false,
        };
    },
    computed: {
        ...mapGetters({
            isRecaptchaReady: 'ui/recaptcha/isReady',
            recaptchaResponse: 'ui/recaptcha/response',
        }),
    isRecaptchaFilled() {
        return Boolean(this.recaptchaResponse);
    },

        isEmailValid() {
            return isValidEmail(this.email);
        }
    },
    methods: {
        validate(event) {
            this.emailError = '';
            
            const trimmedEmail = this.email.trim();
            
            this.isRecaptchaFilled = Boolean(this.recaptchaResponse);
            
            if (isValidEmail(trimmedEmail) && this.isRecaptchaFilled) {
                this.submittedForm = true;
                return true;
            } else {
                if (!trimmedEmail) {
                    this.emailError = gettext('Please fill in this field');
                } else if (!isValidEmail(trimmedEmail)) {
                    this.emailError = gettext('This is not a valid email');
                }
                
                this.$nextTick().then(() => {
                    this.$skokka.scrollToError();
                });
                
                event.preventDefault();
                return false;
            }
        }
    }
};

</script>
